// extracted by mini-css-extract-plugin
export default {"page":"SignUpPage_page__m46Ik","wrapper":"SignUpPage_wrapper__yx87a"};